import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ViewTopBar from "../common_components/viewChanger";
import BottomBar from "../common_components/bottom_bar.component";
import { Link, withRouter } from "react-router-dom";
import config from "../../config";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import logo from "../../assets/img/cw_logo.png";

const BACKEND_URL = config.backend.host;

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: 3,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  text_title: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "500",
    "@media (min-width:200px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:600px)": {
      fontSize: "2rem",
    },
    "@media (min-width:960px)": {
      fontSize: "3rem",
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    textAlign: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#FFF",
    width: 210,
    borderColor: "#F6277F",
    borderWidth: 40,
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "#000 !important",
  },
  signin_text: {
    color: "#F6277F",
    fontFamily: "Open Sans",
    fontWeight: "600",
    textShadowColor: "rgba(0, 0, 0, 0.75)",
    textShadowOffset: { width: -1, height: 1 },
    textShadowRadius: 10,
  },
  join_text: {
    color: "#F6277F",
    fontWeight: "600",
    fontFamily: "Open Sans",
    textTransform: "none",
  },
  enter_text: {
    color: "#FFF",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  new_text: {
    color: "#000",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  progress_color: {
    color: "#FFF",
  },
});

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
    };
    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount() {
    sessionStorage.clear();
  }

  componentDidMount() {
    document.title = "Forgot Password | CanaWho";
  }

  submitForm() {
    const { email } = this.state;
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (email) {
      if (!email.match(mailformat)) {
        this.setState({ email_err: true });
      } else {
        this.setState({ loading: true });
        const obj = {
          email: email.toLowerCase(),
        };
        axios
          .post(BACKEND_URL + `/brand/forgotPassword`, obj)
          .then((res) => {
            // console.log(res.data);
            this.setState({ loading: false });
            if (res.data == "Email not found") {
              alert("Email not found.");
            } else {
              alert(
                "Reset link has been sent to your registered email address."
              );
            }
          })
          .catch((error) => {
            this.setState({ loading: false });
            // Error 😨
            if (error.response) {
              alert("Sign In failed - " + error.response.data.message);
              // console.log(error.response.data);
              // console.log(error.response.status);
              // console.log(error.response.headers);
            } else if (error.request) {
              alert("The server is down, we are fixing it right now.");
              // console.log(error.request);
            } else {
              // Something happened in setting up the request and triggered an Error
              alert("Error - " + error.message);
              // console.log("Error", error.message);
            }
            // console.log(error.config);
          });
      }
    } else {
      alert("Please enter the email address");
    }
  }

  render() {
    const { classes } = this.props;
    const { email_err, loading } = this.state;

    return (
      <div className={classes.root}>
        <ViewTopBar />
        <Grid container direction="column" alignItems="center" justify="center">
          <h1 class={classes.text_title}>
            <u>Company Community</u>
          </h1>
          <Paper style={{ width: 500, alignItems: "center" }}>
            <Container component="main" maxWidth="xs">
              <CssBaseline />
              <div className={classes.paper}>
                <Typography
                  component="h1"
                  variant="h4"
                  className={classes.signin_text}
                >
                  Forgot Password
                </Typography>
                <form className={classes.form} noValidate>
                  <TextField
                    error={email_err}
                    helperText={
                      email_err ? "Please enter a valid email address" : null
                    }
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    onChange={(text) => {
                      this.setState({
                        email: text.target.value,
                        email_err: false,
                      });
                    }}
                    InputLabelProps={{ style: { color: "#000" } }}
                    InputProps={{
                      classes: { notchedOutline: classes.notchedOutline },
                    }}
                  />
                  <Grid container spacing={24}>
                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        style={{
                          backgroundColor: "#F6277F",
                          boxShadow: "2",
                          width: 210,
                        }}
                        className={classes.submit}
                        onClick={() => this.submitForm()}
                        disabled={loading}
                      >
                        {loading ? (
                          <CircularProgress
                            className={classes.progress_color}
                            size={25}
                          />
                        ) : (
                          <Typography
                            variant="h7"
                            className={classes.enter_text}
                          >
                            Reset
                          </Typography>
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
                <Grid>
                  <img
                    alt=""
                    style={{ padding: 10, marginTop: 16, height: 80 }}
                    src={logo}
                  />
                </Grid>
              </div>
            </Container>
          </Paper>
        </Grid>
        <Grid style={{ width: "100%", marginTop: "14%" }}>
          <BottomBar />
        </Grid>
      </div>
    );
  }
}

ForgotPassword.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(ForgotPassword));
